import { ArrowLeft } from "../icons";
import { Button } from "../elements/Button";
import { PageBarBackButtonProps } from "./PageBarBackButton.types";

/** Shared back-navigation icon button for entity page bars. */
export function PageBarBackButton({ title, onClick }: PageBarBackButtonProps) {
  return (
    <Button
      title={title}
      icon={ArrowLeft}
      className="border rounded-2 bg-white hover-bg-light d-flex align-items-center justify-content-center p-0 header-bar-icon-btn"
      onClick={onClick}
    />
  );
}

export default PageBarBackButton;
